import React, { useMemo, useState, useEffect } from "react";

function formatKickoff(iso) {
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function ScheduleSidebar({
  fixtures = [],
  loading = false,
  err = null,
}) {
  const [open, setOpen] = useState(true);

  // Default: expanded on desktop, collapsed on mobile
  useEffect(() => {
    if (typeof window !== "undefined" && window.matchMedia) {
      const mq = window.matchMedia("(max-width: 600px)");
      setOpen(!mq.matches);
    }
  }, []);

  const visible = useMemo(() => {
    return [...fixtures].sort(
      (a, b) => new Date(a.kickoff) - new Date(b.kickoff)
    );
  }, [fixtures]);

  return (
    <div className="scheduleCard">
      <div className="scheduleHeader">
        <span className="scheduleTitle">Schedule</span>
        <button
          type="button"
          className="collapseBtn"
          aria-expanded={open}
          aria-controls="schedule-body"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="collapseIcon" aria-hidden="true">
            {open ? "▾" : "▸"}
          </span>
          <span className="collapseLabel">{open ? "Hide" : "Show"}</span>
        </button>
      </div>

      <div
        id="schedule-body"
        className="scheduleBody"
        data-open={open ? "true" : "false"}
        aria-hidden={open ? "false" : "true"}
      >
        <div className="scheduleInner">
          <div className="scheduleTableWrap">
            {loading && <div className="emptyRow">Loading fixtures…</div>}
            {err && <div className="emptyRow">Error: {err}</div>}

            {!loading && !err && (
              <table className="scheduleTable">
                <tbody>
                  {visible.map((fx) => (
                    <tr key={fx.id}>
                      <td>
                        <span className="fixtureDate">
                          {formatKickoff(fx.kickoff)}
                        </span>
                        <span className="fixtureTeams">
                          {fx.home} <span className="vs">vs</span> {fx.away}
                        </span>
                        {fx.venue && (
                          <span className="fixtureVenue"> · {fx.venue}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                  {visible.length === 0 && (
                    <tr>
                      <td className="emptyRow">No fixtures.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
